<style>
    ::-webkit-scrollbar {
        width: 2px;
    }
    ::-moz-scrollbar {
        width: 2px;
    }
    ::scrollbar {
        width: 2px;
    }

	.button-filter-active {
		background: #045532;
		border:none;
	}
	.button-filter-active strong {
		color: #f7f7f7;
	}

	.button-filter {
		background: #f7f7f7 !important;
		border:none;
	}	
	.button-filter strong {
		color: #222 !important;
    }
    .wow {
        white-space: nowrap;
    }
</style>
<template>
    <main class="vx-row">
        <div class="vx-col w-full flex justify-start" style="overflow-x: auto;">
            <button class="rounded-full button-filter-active wow px-3 mx-2" id="button-all" @click.prevent="filterCampaign('all', 'button-all')">
                <strong>
                    Semua
                </strong>
            </button>
            <button
                v-for="(item, i) in categories"
                :key="i"
                class="rounded-full wow py-2 px-3 mx-2 button-filter"
                :id="`button-${i}`"
                @click.prevent="filterCampaign(item.id, `button-${i}`)"
            >
                <strong >{{ truncateString(item.name, 10)}}</strong>
            </button>
        </div>
    </main>
</template>
<script>
    export default {
        props: {
            categories: {
                type: Array,
                required: true
            }
        },
        methods: {
            filterCampaign(type, id) {
                document.getElementsByClassName('wow').forEach(item => {
                    item.setAttribute('class', 'button-filter px-4 py-2 mx-2 wow rounded-full')
                })

                document.getElementById(id).setAttribute('class', 'button-filter-active px-4 py-2 mx-2 wow rounded-full')
                this.$emit('filter', type)
            }
        }
    }
</script>
